import { ModalStyled } from 'components/UI/styled/modal-styled';
import React from 'react';
import Container from 'react-bootstrap/esm/Container';
import { Indicacao } from 'models/indicacoes';
import {Link} from "react-router-dom";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  indicacao?: Indicacao;
}

const FinalizarIndicacaoModal = (props: Props) => {
  return (
    <ModalStyled
      show={props.isOpen}
      onHide={props.onClose}
      className="modal-md"
    >
      <ModalStyled.Header closeButton>
        <ModalStyled.Title>
          Obrigado por fazer a indicação especial!
        </ModalStyled.Title>
      </ModalStyled.Header>

      <ModalStyled.Body>
        <Container fluid className="pl-0 pr-0">
          <p>A partir de agora a solicitação estará disponível para o estudante dar seguimento no processo de solicitação de crédito.</p>
          <div className="talign-right">
            <Link className="mr-1 btn btn-primary text-white pt-2" to="/indicacao-especial-historico">Acessar histórico</Link>
            <Link className="btn btn-primary text-white pt-2" to="/">Acessar tela inicial</Link>
          </div>
        </Container>
      </ModalStyled.Body>
    </ModalStyled>
  );
}

export default FinalizarIndicacaoModal;